module.exports = __webpack_public_path__ + "static/media/icb-featured.4b2eca47.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/featured-imgs/icb-featured.jpg
// module id = 471
// module chunks = 0